/**
 * Interface representing a data object within a DeckGL layer
 */
export interface DeckGLObject<T = unknown> {
  /** Unique identifier for the object */
  id?: string;
  /** Properties associated with the object */
  properties?: T;
  /** Additional properties that may be present on specific object types */
  [key: string]: unknown;
}

/**
 * Interface representing a DeckGL layer
 */
export interface DeckGLLayer<TProps = unknown, TData = unknown> {
  /** Unique identifier for the layer */
  id?: string;
  /** Layer properties */
  props?: TProps;
  /** Layer data */
  data?: TData;
  /** Additional layer properties */
  [key: string]: unknown;
}

/**
 * Interface representing the info object passed to DeckGL event handlers
 * such as getTooltip, onClick, onHover, etc.
 */
export interface DeckGLInfo<TObject = unknown, TLayerProps = unknown, TLayerData = unknown> {
  /** The data object associated with the hovered/clicked element */
  object?: DeckGLObject<TObject>;
  /** The layer that contains the object */
  layer?: DeckGLLayer<TLayerProps, TLayerData>;
  /** The index of the object in the layer's data array */
  index?: number;
  /** The coordinate of the mouse event */
  coordinate?: [number, number];
  /** The pixel coordinate of the mouse event */
  pixel?: [number, number];
}
